export default __webpack_public_path__ + "images/neighboring-planets.svg";